export default __webpack_public_path__ + "5a439842b6a4d6cd1a14a5c4555a754d.png";